import { render, staticRenderFns } from "./SchoolVideoPlayer.vue?vue&type=template&id=3ca22676&scoped=true"
import script from "./SchoolVideoPlayer.vue?vue&type=script&lang=js"
export * from "./SchoolVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./SchoolVideoPlayer.vue?vue&type=style&index=0&id=3ca22676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca22676",
  null
  
)

export default component.exports